<div id="utf-registration-verify-screen" [ngStyle]="{'height.px':divHeight1}">
  <div class="row no-gutters" [ngStyle]="{'height.px':divHeight1}">
    <div class="col-lg-4">
      <app-progress-tracker [stepOneIcon]="stepOneIcon" [stepOneTickIcon]="stepOneTickIcon" [stepOneDone]="stepOneDone"
        [stepTwoInformationpage]="stepTwoInformationpage" [stepTwoProfileDone]="stepTwoProfileDone"
        [stepTwoDone]="stepTwoDone" [progressTrackerStatus]="progressTrackerStatus"
        (progressTrackerEvent)="handleProgressTrackerEvent($event)"></app-progress-tracker>
    </div>
    <div class="col-lg-8" id="form-component-section">
      <app-utf-registration-verify-form (clearTimeout)="clearTimeout($event)"></app-utf-registration-verify-form>
    </div>
  </div>
  <div [ngClass]="showInactivityModal ? 'open-utf-inactivity-modal' : ''">
    <app-customer-inactivity-utf-modal [openModal]="openInactivityModal"
      (closeInactivityModal)="closeInactivityModal($event)">
    </app-customer-inactivity-utf-modal>
  </div>
</div>